import React from "react";
import { ThemedInputView } from "./view";
import { styles } from "./styles";

export const ThemedInput = React.forwardRef((props, ref) => (
  <ThemedInputView {...props} extrastyles={styles} ref={ref} />
));
